import { BillingLink, Subscription } from '../types';

export const MOCK_RESPONSE_GET_BILLING_LINK: BillingLink = {
  link: 'https://billing.stripe.com/p/session/mock_billing_link',
};

export const MOCK_RESPONSE_GET_SUBSCRIPTION: Subscription = {
  id: 'sub_mock_1',
  active: true,
  startAt: '2026-04-01T00:00:00Z',
  plan: {
    id: 'plan_start',
    nickname: 'Start',
    type: 'STANDARD',
    price: {
      price: { amount: 20, currency: 'EUR' },
      interval: {
        type: 'MONTH',
        count: 1,
      },
    },
  },
  trialData: {
    active: false,
    startAt: null,
    endAt: null,
  },
  payment: {
    method: 'CARD',
    nextDate: '2026-05-01T00:00:00Z',
    interval: { type: 'MONTH', count: 2 },
  },
  usage: {
    price: { amount: 4000, currency: 'EUR' },
    metrics: [
      { name: 'LEARNING_LICENSES', value: 20, max: 200 },
      { name: 'ADMIN_LICENSES', value: 2 },
    ],
  },
};
